<div class="emds">
  <div class="modal-default" id="{{Id}} + 'select-color'">
    <div class="modal-header">
      <p translate>Select a Color
        <span>
          <ng-container *ngIf="selectedColor.name">{{ '(' + selectedColor.name + ')' }}</ng-container>
        </span></p>
    </div>
    <div class="modal-body">
      <button class="color-square"
           *ngFor="let color of colors"
           [style.background]="color.hexCode"
           [ngClass]="{'selected': color.hexCode === selectedColor.hexCode}"
           (click)="selectColor(color)">
      </button>
    </div>
    <div class="modal-footer">
      <button type="submit" id="{{ baseId }}-save-btn" class="btn btn-primary" (click)="saveColor()" [disabled]="!isSaving" translate>
       Save
      </button>
      <button type="button" id="{{ baseId }}-cancel-btn" class="btn btn-secondary btn-flush-right" (click)="noSelected()" translate>
        Cancel
      </button>
    </div>
  </div>
</div>
